import { lazy, type LazyExoticComponent } from 'react';

import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

export const PlanCompleteRendererAsync: LazyExoticComponent<
	(props: ActionRendererFor<'plan_complete'>) => React.JSX.Element
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/plan-complete-renderer" */ './PlanCompleteRenderer'
	).then((m) => ({ default: m.PlanCompleteRenderer })),
);
